/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["table[_ngcontent-%COMP%]{width:100%}.example-button-row[_ngcontent-%COMP%]   a[_ngcontent-%COMP%], .example-button-row[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{margin-left:85%}"];
export { styles as styles };
